import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Tab,
  Tabs,
  OverlayTrigger,
  Tooltip,
  Modal,
} from 'react-bootstrap';
import InnerHeader from '../components/InnerHeader';
import ChevrontoggleIcon from '../assets/icons/chevrontoggle';
import InnerPageWrap from '../components/InnerPageWrap';
import { pageURLs } from '../appData/pageURLs';
import KOSelectBox from '../components/KOSelectBox';
import '../styles/payment.scss';
import * as userController from '../controller/userController';
import TESVOPayment from '../components/TsevoPayment';
import * as transactionController from '../controller/transactionController';
import { store } from '../appState/store';
import useUserState from '../appState/userState/useUserState';
import * as commonService from '../services/commonService';
import KOInput from '../components/KOInput';
import { useNavigate } from 'react-router-dom';
import TsevoPaymentWithdrawal from '../components/TsevoPaymentWithdrawal';
import * as userService from '../services/userService';
import useGeoLocation from '../utils/useGeoLocation';
import { checkIpFormat } from '../utils/CommonHelper';
import KORadiobutton from '../components/KORadiobutton';

import * as GIDX from 'gidx-js';
import Dotimg from '../assets/card-dots.svg';
import Plusimg from '../assets/plus-icon.svg';
import Deleteicon from '../assets/trash-can-icon.svg';
import { set } from 'lodash';
const Withdrawfund = (props) => {
  const userData = store.getState().user;
  const user = useUserState();
  const location = useGeoLocation();
  let firstName = userData.user.first_name;
  let lastName = userData.user.last_name;
  let email = userData.user.email;
  let userFullName = userData.user.user_full_name;
  let dob = userData.user.dob;
  let stateCode = userData.user.state_code;
  let user_status = userData.user.user_status_id;
  let countryCode = userData.user.country_code;
  let city = userData.user.city;
  let address = userData.user.address;
  let zipCode = userData.user.zip_code;
  let tsevo_customer_id = userData.user.tsevo_customer_id;
  let user_id = userData.user.user_id;
  let wallet_amount = userData.user.wallet_amount;
  const navigate = useNavigate();

  const [Flag_ShowSideMenu, setFlag_ShowSideMenu] = useState(false);
  const [paymentSession, setPaymentSession] = useState('');
  const [stepState, setStepState] = useState('');

  const [showLoader, SetShowLoader] = useState(false);
  const [withdrawProcessFlag, SetWithdrawProcessFlag] = useState(false);
  const [amountToWithdraw, SetAmountToWithdraw] = useState('');
  const [withDrawalError, SetWithDrawalError] = useState('');
  const [selfExclusionProcessed, SetSelfExclusionProcessed] = useState(false);
  const [selfExclusionConfirmScreen, SetSelfExclusionConfirmScreen] =
    useState(false);
  const [isGeolocationAvailable, SetGeolocationAvailable] = useState(false);
  const [isGeolocationEnabled, SetGeolocationEnabled] = useState(false);
  const [coords, setcoords] = useState({});
  const [showVerificationProcessModal, setshowVerificationProcessModal] =
    useState(false);
  const [notverifiedMessage, setnotverifiedMessage] = useState(
    'Complete verification to withdraw cash'
  );
  const [verificationBtnTitle, setverificationBtnTitle] = useState(
    'Continue with Verification'
  );
  const [paymentSessionURL, setPaymentSessionURL] = useState('');
  const [isIpisV4, setisIpisV4] = useState(false);
  const [paymentTypeValue, setpaymentTypeValue] = useState('CC');
  const [showPaymentRedirectionModal, setPaymentRedirectionModal] =
    useState(false);
  const [achActumPaymentLink, setachActumPaymentLink] = useState('');
  const containerRef = useRef(null);
  const [sessionData, setSessionData] = useState(null);
  const [customerCards, setCustomerCards] = useState([]);
  const [selectedCardToken, setSelectedCardToken] = useState(null);
  const [showNewCardAddForm, setShowNewCardAddForm] = useState(false);
  const [selectedCardNumber, setSelectedCardNumber] = useState(null);
  const [customerDeviceIp, setCustomerDeviceIp] = useState(null);
  const [creditCardpaymentCompleted, setCreditCardPaymentCompleted] =
    useState(false);
  const [cardDisplayFormTitle, setCardDisplayFormTitle] =
    useState('Add New Card');
  const [displayAddNewCardButton, setDisplayAddNewCardButton] = useState(false);
  const [addingNewCreditCard, setAddingNewCreditCard] = useState(false);
  let ccForm = null;
  const ccformRef = useRef(null); // Store GIDX form object
  const [showPaymentProcessScreen, SetPaymentProcessScreen] = useState(false);

  const paymentprocess = 'PaymentProcess';
  const withdrawamount = 'withdrawamount';
  const hidePaymentProcessModal = () => {
    SetPaymentProcessScreen(false);
    window.location.reload();
  };

  const getSideMenuClasses = () => {
    let result = 'koblock-right content-block-rht Payment-info';
    if (Flag_ShowSideMenu) {
      result += ' sidebarvisible';
    } else {
      result += ' sidebarhidden';
    }
    return result;
  };

  const handleWithdrawalchange = (e) => {
    SetWithDrawalError('');
    if (Number(e.target.value)) {
      SetAmountToWithdraw(e.target.value);
    } else {
      SetAmountToWithdraw('');
      SetWithDrawalError('Enter valid amount');
    }
  };
  const validate = () => {
    let isValid = true;
    if (amountToWithdraw == 0) {
      isValid = false;
      SetWithDrawalError('Enter a valid amount');
    }

    return isValid;
  };

  const withdrawAmountProcess = async () => {
    let isValid = validate();
    SetWithDrawalError('');
    if (user_status != 1) {
      SetWithDrawalError('Your identity is not verified.');
      return false;
    }
    if (!amountToWithdraw) {
      isValid = false;
      SetWithDrawalError('Enter a valid amount');
      return false;
    }
    if (isNaN(amountToWithdraw)) {
      isValid = false;
      SetWithDrawalError('Enter a valid amount');
      return false;
    }
    if (amountToWithdraw <= 0) {
      //https://3.basecamp.com/4513320/buckets/25004187/messages/6181097964
      isValid = false;
      SetWithDrawalError('Minimum withdrawal amount should be more than $0.');
      return false;
    }
    if (isValid) {
      if (paymentTypeValue === 'ACTUM') {
        await proceedActumPayment();
      } else {
        await proceedCreditCardPayment();
      }
    }
  };

  const changeTabs = async (tab) => {
    if (tab == 'withdrawcash') {
      navigate(pageURLs.withdrawfund);
    } else {
      navigate(pageURLs.payment);
    }
  };

  const showSelfExlusionProcessModal = () => {
    SetSelfExclusionConfirmScreen(true);
  };
  const hideSelfExlusionProcessModal = () =>
    SetSelfExclusionConfirmScreen(false);

  const selfExclusion = async () => {
    //setSelfExclusionLoader(true)
    await userService.userSelfBlocking('3m').then(async function (response) {
      //setSelfExclusionLoader(false)
      if (response.errorCode == 200) {
        if (response.data.refundRequired) {
          navigate(pageURLs.withdrawfund);
        } else {
          await user.action.logout();
          sessionStorage.removeItem('contestId');
          sessionStorage.removeItem('lineupsArray');
          window.location.href = pageURLs.root;
        }
      } else {
        alert(response.message);
      }
    });
  };
  useEffect(() => {
    if (location.loaded && !location.errorFlag) {
      SetGeolocationAvailable(true);
      SetGeolocationEnabled(true);
      setcoords(location.coordinates);
    } else if (location.loaded && location.errorFlag) {
      SetGeolocationAvailable(false);
      SetGeolocationEnabled(false);
      setcoords({});
    }
  }, [location]);

  const continueVerification = (e) => {
    navigate(pageURLs.Verificationstart);
  };

  const closeVerification = (e) => {
    setshowVerificationProcessModal(false);
  };

  useEffect(async () => {
    if (user_status != 1) {
      //Not verified users
      if (
        user_status == 4 &&
        (user.data.user.tsevo_status_id == 1 ||
          user.data.user.tsevo_status_id == 2)
      ) {
        //Verification failed or not started the verification
        setnotverifiedMessage('Complete verification to add cash');
      } else if (
        (user_status == 4 || user_status == 5) &&
        user.data.user.tsevo_status_id == 3
      ) {
        //Verification failed or not started the verification
        setnotverifiedMessage(
          'Identity verification was unsuccessful. Please try again. If you continue to encounter difficulties, please reach out to a Knockout representative at admin@fantasysportsknockout.com for assistance.'
        );
      } else if (user_status == 5) {
        setnotverifiedMessage(
          'Your identity verification is still in progress. Please be patient - in rare cases, verification can take up to 24 hours. If it has been 24 hours or longer, please contact Knockout customer care at admin@fantasysportsknockout.com.'
        );
        setverificationBtnTitle('Retry verification');
      }
      setshowVerificationProcessModal(true);
      return false;
    }
  }, [user_status]);

  const handlePaymentTypeChange = (e) => {
    const { name, value } = e.target;
    setpaymentTypeValue(value);
  };

  const closePaymentProcessScreen = (e) => {
    setPaymentRedirectionModal(false);
    setachActumPaymentLink(null);
    setpaymentTypeValue('CC');
    SetAmountToWithdraw('');
  };

  const processPayment = (e) => {
    setPaymentRedirectionModal(false);
    setpaymentTypeValue('CC');
    SetAmountToWithdraw('');
    window.open(achActumPaymentLink, '_blank').focus();
  };

  const proceedActumPayment = async () => {
    SetWithdrawProcessFlag(true);
    SetShowLoader(true);
    await userController.getUserIp().then(async function (ipdata) {
      let customerIp = ipdata.data ? ipdata.data.IPv4 : null;
      if (customerIp) {
        await transactionController
          .createTransactionRecord(
            amountToWithdraw,
            'withdrawal',
            customerIp,
            coords,
            paymentTypeValue
          )
          .then(async function (orderData) {
            if (orderData.errorCode == 200) {
              let sessionID = orderData.data.sessionID;
              let is_state_legal = orderData.data.isleagalState
                ? orderData.data.isleagalState
                : 0;
              let userResponse =
                await user.action.SetUserStateLeagalData(is_state_legal);
              if (sessionID !== null) {
                if (paymentTypeValue === 'ACTUM') {
                  await transactionController
                    .completePayment(
                      amountToWithdraw,
                      'withdrawal',
                      orderData.data.transaction_id
                    )
                    .then(async function (completePaymentData) {
                      if (
                        completePaymentData.errorCode === 200 &&
                        completePaymentData.data.actionUrl
                      ) {
                        SetWithdrawProcessFlag(false);
                        SetShowLoader(false);
                        //window.open(completePaymentData.data.actionUrl, '_blank').focus();
                        setachActumPaymentLink(
                          completePaymentData.data.actionUrl
                        );
                        setPaymentRedirectionModal(true);
                      } else {
                        let is_state_legal = orderData.data.isleagalState
                          ? orderData.data.isleagalState
                          : 0;
                        let userResponse =
                          await user.action.SetUserStateLeagalData(
                            is_state_legal
                          );
                        SetWithdrawProcessFlag(false);

                        SetShowLoader(false);
                        SetWithDrawalError(
                          'Could not process the request. Please try again later.'
                        );
                      }
                    });
                } else {
                  setPaymentSession(sessionID);
                  setPaymentSessionURL(orderData?.data?.sessionUrl);

                  setStepState(withdrawamount);
                  SetShowLoader(false);
                  await user.action.setPaymentProcessedStatus(true);
                  // console.log("Self exlsuion status", orderData.data.isSelfExclusionProcessed)
                  if (orderData.data.isSelfExclusionProcessed) {
                    SetSelfExclusionProcessed(true);
                  } else {
                    SetSelfExclusionProcessed(false);
                  }
                }
              } else {
                SetWithdrawProcessFlag(false);
                SetShowLoader(false);
                SetSelfExclusionProcessed(false);
              }
            } else {
              let is_state_legal = orderData.data.isleagalState
                ? orderData.data.isleagalState
                : 0;
              let userResponse =
                await user.action.SetUserStateLeagalData(is_state_legal);
              SetWithdrawProcessFlag(false);
              SetShowLoader(false);
              SetWithDrawalError(orderData.message);
              SetSelfExclusionProcessed(false);
            }
          });
      } else {
        SetWithdrawProcessFlag(false);
        SetShowLoader(false);
        SetWithDrawalError(
          'Could not process the request. Please try again later.'
        );
        SetSelfExclusionProcessed(false);
      }
    });
  };

  const proceedCreditCardPayment = async () => {
    SetShowLoader(true);
    const ipdata = await userController.getUserIp();
    let customerIp = ipdata.data ? ipdata.data.IPv4 : null;
    if (customerIp) {
      setCustomerDeviceIp(customerIp);
      const data = await transactionController.createDirectCCSession(
        amountToWithdraw,
        'withdrawal',
        coords,
        customerIp,
        paymentTypeValue
      );
      if (data?.errorCode === 200) {
        SetWithdrawProcessFlag(true);
        setSessionData(data);
      } else {
        SetWithdrawProcessFlag(false);
        SetShowLoader(false);
        SetWithDrawalError(
          data?.message ||
            'Could not process the request. Please try again later.'
        );
        SetSelfExclusionProcessed(false);
      }
    }
    SetShowLoader(false);
  };

  useEffect(() => {
    console.log('Session data changed:', sessionData);
    if (!sessionData) return;

    const merchantId =
      sessionData?.data?.MerchantID ?? process.env.REACT_APP_TSEVO_MERCHANT_ID;
    const environment = process.env.REACT_APP_TSEVO_ENVIRONMENT ?? 'production';

    // Initialize GIDX
    GIDX.init({ merchantId, environment });

    // Find CC settings from response
    const ccSettings = sessionData?.data?.PaymentMethodSettings?.find(
      (s) => s.Type === 'CC'
    );

    const ccPayments =
      sessionData?.data?.PaymentMethods?.filter(
        (payment) => payment.Type === 'CC'
      ) ?? [];
    setCustomerCards(ccPayments);
    if (selectedCardNumber === null) {
      const defaultSelectedCard =
        ccPayments?.length > 0 ? ccPayments[0].Token : null;
      const defaultSelectedCardNumber =
        ccPayments?.length > 0 ? ccPayments[0].LastFour : null;
      setSelectedCardToken(defaultSelectedCard);
      setSelectedCardNumber(defaultSelectedCardNumber);
    }
    // 🚀 Show loader before starting form render
    SetShowLoader(true);
    // Remove old form before creating a new one
    if (ccformRef.current) {
      if (typeof ccformRef.current.destroy === 'function') {
        ccformRef.current.destroy();
      } else {
        containerRef.current.innerHTML = ''; // fallback
      }
      ccformRef.current = null;
    }
    // Start observing the container for changes(For showing loader while loading the card form)
    const observer = new MutationObserver(() => {
      if (containerRef.current && containerRef.current.children.length > 0) {
        // Form content appeared → hide loader
        SetShowLoader(false);
        observer.disconnect();
      }
    });
    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });
    }
    const shouldShowFullForm = showNewCardAddForm || ccPayments?.length === 0;
    if (shouldShowFullForm && ccSettings?.Tokenizer) {
      setAddingNewCreditCard(true);
      setCardDisplayFormTitle('Add New Card');
      setDisplayAddNewCardButton(false);
      setSelectedCardToken(null);
      setSelectedCardNumber(null);

      // Render the GIDX form
      ccForm = GIDX.showPaymentMethodForm(containerRef.current.id, {
        merchantSessionId: sessionData?.data?.MerchantSessionID,
        paymentMethodTypes: ['CC'],
        tokenizer: ccSettings.Tokenizer,
        theme: 'material',
        styles: {
          base: {
            fontSize: '20px',
            color: '#fff',
            fontFamily: 'Poppins, sans-serif',
          },
          label: {
            color: '#fff !important',
          },
          input: {
            borderRadius: '8px',
            border: '1px solid #ccc',
            padding: '25px',
          },
        },
        fields: ['name', 'number', 'expiry', 'cvc'],
      });
      ccformRef.current = ccForm; // Store form instance
    } else if (ccPayments?.length > 0 && ccSettings?.Tokenizer) {
      setCardDisplayFormTitle('CVV');
      setDisplayAddNewCardButton(true);
      setAddingNewCreditCard(false);
      ccformRef.current = GIDX.showPaymentMethodForm(containerRef.current.id, {
        merchantSessionId: sessionData?.data?.MerchantSessionID,
        paymentMethodTypes: ['CC'],
        tokenizer: ccSettings.Tokenizer,
        cvvOnly: true,
        theme: 'material',
        styles: {
          base: {
            fontSize: '20px',
            color: '#fff',
            fontFamily: 'Poppins, sans-serif',
          },
          label: {
            color: '#fff !important',
          },
          input: {
            borderRadius: '8px',
            border: '1px solid #ccc',
            padding: '25px',
          },
        },
        existingPaymentMethodToken: selectedCardToken,
      });
    } else {
      SetWithDrawalError(
        'Could not process the request. Please try again later.'
      );
      SetShowLoader(false);
      setSessionData(null);
      SetWithdrawProcessFlag(false);
    }
  }, [showNewCardAddForm, sessionData]);

  const handleCardSelect = (selectedToken, selectedNumber) => {
    setSelectedCardToken(selectedToken);
    setSelectedCardNumber(selectedNumber);
    setShowNewCardAddForm(false);
    setCardDisplayFormTitle('CVV');
    setDisplayAddNewCardButton(true);
    setAddingNewCreditCard(false);
  };
  // complete the cc payment
  const completeCreditCardPayment = async () => {
    SetShowLoader(true);
    SetWithDrawalError('');
    const paymentPayload = {
      transaction_action: 'withdrawal',
      transaction_amount: amountToWithdraw,
      customerIp: customerDeviceIp,
      time: new Date(),
      accuracy: coords.accuracy ? coords.accuracy : null,
      altitude: coords.altitude ? coords.altitude : null,
      latitude: coords.latitude ? coords.latitude : null,
      longitude: coords.longitude ? coords.longitude : null,
      speed: coords.speed ? coords.speed : null,
      paymentType: 'CC',
      paymentMethodToken: null,
      savePaymentMethod: false,
      existingPaymentMethod: false,
      currentSessionID: sessionData?.data?.transaction_id,
      paymentMethod: {
        Type: 'CC',
        NameOnAccount: '',
        CVV: '',
        ExpirationDate: '',
        ProcessorToken: {
          Processor: 'Evervault',
          Token: '',
        },
      },
    };
    let callAPI = false;
    if (
      ccformRef.current &&
      addingNewCreditCard &&
      ccformRef?.current?.card?.values?.isValid
    ) {
      callAPI = true;
      paymentPayload.paymentMethod.NameOnAccount =
        ccformRef?.current?.card?.values?.card?.name;
      paymentPayload.paymentMethod.CVV =
        ccformRef?.current?.card?.values?.card?.cvc;
      paymentPayload.paymentMethod.ExpirationDate = `${ccformRef?.current?.card?.values?.card?.expiry?.month}/${ccformRef?.current?.card?.values?.card?.expiry?.year}`;
      paymentPayload.paymentMethod.ProcessorToken.Token =
        ccformRef?.current?.card?.values?.card?.number;
      paymentPayload.savePaymentMethod = true;
      // console.log('Submitting payment with new card form', paymentPayload);
      //ccformRef.current.submit()
    } else if (
      !addingNewCreditCard &&
      ccformRef?.current?.card?.values?.isValid
    ) {
      callAPI = true;
      paymentPayload.paymentMethodToken = selectedCardToken;
      paymentPayload.existingPaymentMethod = true;
      paymentPayload.paymentMethod.CVV =
        ccformRef?.current?.card?.values?.card?.cvc;
      // console.log('Submitting payment without new card form', paymentPayload);
      // Handle payment submission without new card form
    } else {
      SetWithDrawalError('Please enter a valid card details');
      SetShowLoader(false);
    }
    if (callAPI === true) {
      const data =
        await transactionController.completeDirectCCSession(paymentPayload);
      SetShowLoader(false);
      if (data?.errorCode === 200) {
        if (data?.data?.Action?.Type == '3DSChallenge') {
          GIDX.show3DSChallenge(data?.data?.Action, {
            onComplete: async function (transactionId) {
              //Send another CompleteSession request after challenge is completed.
              delete paymentPayload.paymentMethod;
              paymentPayload.Type = 'CC';
              paymentPayload.ThreeDS = {
                TransactionID: transactionId,
              };
              paymentPayload.paymentMethodToken =
                data?.data?.PaymentDetails[0]?.PaymentMethodToken;
              SetShowLoader(true);
              //Call CompleteSession API here
              const challengeResponse =
                await transactionController.completeDirectCCSession(
                  paymentPayload
                );
              SetShowLoader(false);
              if (
                challengeResponse?.errorCode === 200 &&
                challengeResponse?.data?.PaymentDetails &&
                challengeResponse?.data?.PaymentDetails[0].PaymentStatusCode ===
                  "1"
              ) {
                SetPaymentProcessScreen(true);
                setCreditCardPaymentCompleted(true);
              } else {
                SetWithDrawalError(
                  'Could not process the request. Please try again later.'
                );
                setSessionData(null);
                SetWithdrawProcessFlag(false);
              }
            },
          });
        } else {
          SetPaymentProcessScreen(true);
          setCreditCardPaymentCompleted(true);
        }
      } else {
        SetWithDrawalError(
          data?.message ||
            'Could not process the request. Please try again later.'
        );
      }
    }
    // console.log("paymentPayload", data?.errorCode);
  };

  const showCardClass = (cardType = 'Visa') => {
    let result = 'credit-card';
    if (cardType === 'MasterCard') {
      result += ' card-2';
    } else {
      result += ' card-1';
    }
    return result;
  };
  return (
    <InnerPageWrap>
      <div className="koinner-sec">
        <div className="koheader-wrap">
          <InnerHeader currentPage={pageURLs.payment} />
        </div>
        <div className="kodata-content">
          <div className="koblock-left content-block-lft Payment-container">
            <div className="sidebar-toggler">
              <Button
                onClick={() => {
                  setFlag_ShowSideMenu(true);
                }}
              >
                <ChevrontoggleIcon />
              </Button>
            </div>
            <Tabs
              defaultActiveKey="withdrawcash"
              transition={false}
              id="payment-tab"
              className="payment-info-tab"
              onSelect={(k) => changeTabs(k)}
            >
              <Tab eventKey="addcash" title="Add Cash"></Tab>
              <Tab eventKey="withdrawcash" title="Withdraw Cash">
                {!withdrawProcessFlag ? (
                  <div className="payment-data">
                    <div className="amount-selector">
                      <div className="multiple-select-box">
                        <div className="form-group radio-field d-flex align-items-center">
                          <KORadiobutton
                            name="cardType"
                            label="Credit Card"
                            id="creditcard"
                            value="CC"
                            checked={paymentTypeValue == 'CC'}
                            onChange={handlePaymentTypeChange}
                          />
                          <KORadiobutton
                            name="cardType"
                            label="Bank Account"
                            id="Authentecheck"
                            value="ACTUM"
                            checked={paymentTypeValue == 'ACTUM'}
                            onChange={handlePaymentTypeChange}
                          />
                        </div>
                      </div>
                      <div className="amount-title">
                        <h5>Enter amount</h5>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              Withdraw available funds to your bank account.
                            </Tooltip>
                          }
                        >
                          <i className="ic-question"></i>
                        </OverlayTrigger>
                      </div>

                      <KOInput
                        id="amount"
                        placeholder="Enter amount"
                        label="Current Email"
                        name="currentmail"
                        type="text"
                        value={amountToWithdraw}
                        onChange={(e) => {
                          handleWithdrawalchange(e);
                        }}
                        errorMessage={withDrawalError}
                      />

                      {user_status == 1 &&
                      isGeolocationAvailable &&
                      isGeolocationEnabled ? (
                        <div className="btn-sec">
                          <Button
                            variant="primary"
                            className="btn-main"
                            onClick={() => {
                              withdrawAmountProcess();
                            }}
                          >
                            Withdraw
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                      {!isGeolocationEnabled && (
                        <div style={{ color: 'red' }}>
                          Geolocation is required for receiving the payment
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {showLoader && (
                  <div className="loader-wrap">
                    <div className="loader"></div>
                  </div>
                )}

                <div className="payment-data">
                  {withdrawProcessFlag &&
                  !creditCardpaymentCompleted &&
                  paymentTypeValue === 'CC' ? (
                    <>
                      <div className="payment-card-sec">
                        {customerCards.length > 0 ? (
                          <>
                            <div className="card-title-block">
                              <h4>Saved Cards</h4>
                              <p>
                                You can add your credit card for the feature
                                purchase and automatically renew.
                              </p>
                            </div>
                            <div className="credit-card-group d-flex">
                              {customerCards.map((cc, index) => (
                                <div
                                  className={showCardClass(cc.Network)}
                                  key={cc.Token || index}
                                >
                                  <div className="card-number d-flex align-items-center">
                                    <img src={Dotimg} alt="Card Dots" />
                                    <h4>{cc.LastFour}</h4>
                                  </div>
                                  <div className="name-expiry d-flex justify-content-between">
                                    <h4>{cc.NameOnAccount}</h4>
                                    <h4>{cc.ExpirationDate}</h4>
                                  </div>
                                  <div className="card-actions d-flex align-items-center justify-content-between">
                                    {/* <Button
                                      variant="link"
                                      className="p-0 btn delete-btn"
                                    >
                                      <img src={Deleteicon} alt="Deletee" />
                                    </Button> */}
                                    <div className="form-group">
                                      <KORadiobutton
                                        name="creditCard"
                                        id={`creditCard_${index}`}
                                        value={cc.Token}
                                        label=""
                                        onChange={() =>
                                          handleCardSelect(
                                            cc.Token,
                                            cc.LastFour
                                          )
                                        }
                                        checked={selectedCardToken === cc.Token}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          ''
                        )}
                        {displayAddNewCardButton && (
                          <Button
                            variant="primary"
                            className="btn-main add-btn d-flex align-items-center"
                            onClick={() => setShowNewCardAddForm(true)}
                          >
                            Add New Card <img src={Plusimg} alt="Plus icon" />
                          </Button>
                        )}
                      </div>

                      <div className="tsevo-container custom-payment-form-wrap">
                        <h4>{cardDisplayFormTitle}</h4>
                        {withDrawalError && (
                          <span style={{ color: 'red' }}>
                            {withDrawalError}
                          </span>
                        )}
                        <div id="gidx-form-container" ref={containerRef}></div>
                      </div>

                      <div className="transaction-summary">
                        <h4>Transaction Summary</h4>
                        <div className="summary-info">
                          <h5>
                            Amount: <span>${amountToWithdraw}</span>
                          </h5>
                          {selectedCardNumber ? (
                            <h5 className="m-0">
                              Card: **** **** **** {selectedCardNumber}
                            </h5>
                          ) : (
                            ''
                          )}
                        </div>
                        <Button
                          variant="success"
                          className="btn-main"
                          onClick={() => completeCreditCardPayment()}
                          disabled={!sessionData?.data ? true : false}
                        >
                          Proceed
                        </Button>
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </Tab>
            </Tabs>
          </div>
          <div className={getSideMenuClasses()}>
            <Button
              className="btn-close"
              onClick={() => {
                setFlag_ShowSideMenu(false);
              }}
            ></Button>
            <h6>Current Balance</h6>
            <h2>{commonService.toCurrency(wallet_amount)}</h2>
          </div>

          <Modal
            show={selfExclusionConfirmScreen}
            onHide={hideSelfExlusionProcessModal}
            className="modal-coupon"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <h4 className="modal-title">Self Exclusion</h4>
              <p className="info">
                Please confirm that you understand Self-Exclusion and wish to
                self-exclude:
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={selfExclusion}>
                Yes
              </Button>
              <Button variant="link" onClick={hideSelfExlusionProcessModal}>
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showVerificationProcessModal}
            onHide={closeVerification}
            className="modal-coupon"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <h4 className="modal-title">Verification</h4>

              <p>{notverifiedMessage}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={continueVerification}>
                {verificationBtnTitle}
              </Button>
              <Button variant="link" onClick={closeVerification}>
                Maybe later
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showPaymentRedirectionModal}
            onHide={closePaymentProcessScreen}
            className="modal-predict"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <h4 className="modal-title">Payment</h4>

              <p>
                You are leaving the site now and will be redirected to our
                secure payment gateway to complete your withdrawal.{' '}
              </p>
              <br />
              <p>Click "Continue" to proceed to the payment page.</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={processPayment}>
                Continue
              </Button>
              <Button variant="link" onClick={closePaymentProcessScreen}>
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showPaymentProcessScreen}
            onHide={hidePaymentProcessModal}
            className="modal-coupon"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <h4 className="modal-title">
                Your cash withdrawal request has been submitted successfully. We
                will review it and process it shortly.
              </h4>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </InnerPageWrap>
  );
};

export default Withdrawfund;
